import { render, staticRenderFns } from "./Acciones.vue?vue&type=template&id=4a587996&scoped=true&"
import script from "./Acciones.vue?vue&type=script&lang=js&"
export * from "./Acciones.vue?vue&type=script&lang=js&"
import style0 from "./Acciones.vue?vue&type=style&index=0&id=4a587996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a587996",
  null
  
)

export default component.exports